import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { luftGet } from '../../../../../shared/http';
import { LOCAL_STORAGE_USER_TYPE } from '../../../../../shared/http/auth';
import { USER_TYPES } from '../../../../Admin/shared/static-options';

import NFFilter from '../components/FilterContainer';
import FilterForm from '../components/FilterForm';
import CheckboxControl from '../components/CheckboxControl';
import InfinityContent from '../components/InfinityContent';
import { cpfOrCnpjMask, customersMask } from '../masks';
import debounce from 'lodash.debounce';
import { useCallback } from 'react';

const SubsidiariesLuft = ({
  isOpen,
  onClick,
  onApply,
  byDate,
  initialPeriod,
  finalPeriod,
  listSubsidiaries,
}) => {
  const [selectedItem, setSelectedItem] = useState(listSubsidiaries);
  const [atualPage, setAtualPage] = useState(1);
  const [data, setData] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [loading, setLoading] = useState(false);
  const [queryParamas, setQueryParams] = useState();
  const [totalLines, setTotalLines] = useState();

  const companyId = window.localStorage.getItem('Luft/CustomerService/CompanyId') || window.localStorage.getItem('Luft/CompanyId');

  useEffect(() => {
    if(listSubsidiaries?.length < 1) {
      setSelectedItem([]);
    }
  }, [listSubsidiaries]);

  const params = {
    page: atualPage,
    amount: 10,
    byDate,
    initialPeriod,
    finalPeriod,
    companyId
  };

  const fetchAllSubsidiaries = async () => {
    if (loading) {
      return;
    }
    try {
      setLoading(true);

      const response = await luftGet(
        '/IntegratedTracking/GetIntegratedTrackingSubsidiaries', 
        params
      );

      setData(prevData => [...prevData, ...response.data]);
      setTotalLines(data.length);
      setAtualPage(prevPage => prevPage + 1);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setAtualPage(0);
    setData([]);
    fetchAllSubsidiaries();
  }, [ 
    byDate,
    initialPeriod,
    finalPeriod
  ]);

  const handleSearchByCustomer = async e => {
    e.preventDefault();
    setQueryParams(e.target.value);
    await debounceFilteredCustomers(e);
  };

  const fetchFilterByCustomer = async e => {
    setLoading(true);
    try {
      const newParams = {
        ...params,
        page: 1,
        query: e.target.value.toLocaleLowerCase().trim(),
      };

      const response = await luftGet(
        '/IntegratedTracking/GetIntegratedTrackingSubsidiaries',
        newParams,
      );
      setDataFilter(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const debounceFilteredCustomers = useCallback(debounce(fetchFilterByCustomer, 1000), []);

  const handleChange = e => {
    if (!e.target.checked) {
      setSelectedItem(
        selectedItem.filter(item => Number(item) !== Number(e.target.value)),
      );
    } else if (e.target.checked) {
      setSelectedItem([...selectedItem, e.target.value]);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    onApply(selectedItem);
  };

  const clearFilter = () => {
    setSelectedItem([]);
    onApply([]);
  };

  const clearSearch = () => {
    setQueryParams('');
  };

  const userType = window.localStorage.getItem(LOCAL_STORAGE_USER_TYPE);

  return USER_TYPES.CUSTOMER_SERVICE_USER === Number(userType) ? (
    <NFFilter
      label="Filial Luft"
      isOpen={isOpen}
      onClick={onClick}
      alignDropdownRight
    >
      <FilterForm
        label="Filtrar por filial emissora (Luft)"
        onSubmit={handleSubmit}
        clearFilter={clearFilter}
      >
        <InfinityContent
          inputSearchLabel="Buscar filial"
          searchChange={handleSearchByCustomer}
          clearSearch={clearSearch}
          data={data}
          dataFiltered={dataFilter}
          fetchAllData={() => fetchAllSubsidiaries()}
          hasMore={
            dataFilter.length !== 0
              ? dataFilter.length < totalLines
              : data.length < totalLines
          }
          queryParamas={queryParamas}
          loading={loading}
        >
          {(queryParamas ? dataFilter : data).map(filter => {
            if (filter.cnpjSubs && filter.name) {
              return (
                <CheckboxControl
                  key={filter.cnpjSubs}
                  value={filter.cnpjSubs}
                  onChange={handleChange}
                  defaultChecked={selectedItem.some(
                    item => parseInt(item) === Number(filter.cnpjSubs),
                  )}
                  title={customersMask(filter.name)}
                  description={cpfOrCnpjMask(filter.cnpjSubs.trim())}
                  infinityList
                />
              )
            }
          })}
        </InfinityContent>
      </FilterForm>
    </NFFilter>
  ) : null;
};

const mapStateToProps = state => ({
  listSubsidiaries: state.tracking.filters.listSubsidiaries,
  byDate: state.tracking.filters.byDate,
  initialPeriod: state.tracking.filters.initialPeriod,
  finalPeriod: state.tracking.filters.finalPeriod,
});

export default connect(mapStateToProps)(SubsidiariesLuft);
